import { Box, Container, Toolbar } from '@mui/material';
import React from 'react';

import { Navigation } from './Navigation';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DRAWER_WIDTH = 240;

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
}) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Navigation />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
          minHeight: '100vh',
          backgroundColor: 'background.default',
        }}
      >
        <Toolbar />
        <Container maxWidth='xl' sx={{ py: 3 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};
